<template>
  <div class="pushconfig-bd tb">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item>
          <el-button type="primary" icon="el-icon-plus" @click="addPaclageItem()" v-if="funcView.push_config_add">{{ funcView.push_config_add }}</el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right; margin-right: 0">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input :placeholder="$t('base_pushConfig.xxmcxxbm')" v-model="formSearch.keyword" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter('keyword')">
      <el-form :inline="true" label-position="top">
        <!--  推送角色 -->
        <el-form-item :label="$t('base_pushConfig.tui_song_jue_se')">
          <custom-select v-model="formSearch.pushRole" url="roleMsgList" :props="{ label: 'roleName', value: 'roleCode' }" :placeholder="$t('Common.com_please_select')" width="100%"></custom-select>
        </el-form-item>
        <!-- 推送范围 -->
        <el-form-item :label="$t('base_pushConfig.tui_song_fan_wei')">
          <custom-select v-model="formSearch.pushRange" code="bas_org_type" :placeholder="$t('Common.com_please_select')" width="100%"></custom-select>
        </el-form-item>
        <!-- 推送渠道 -->
        <el-form-item :label="$t('base_pushConfig.tui_song_qu_dao')">
          <custom-select v-model="formSearch.pushChannel" code="bas_msg_push_template_type" :placeholder="$t('Common.com_please_select')" width="100%"></custom-select>
        </el-form-item>
        <!-- 消息模板 -->
        <el-form-item :label="$t('base_pushConfig.xiao_xi_mu_ban')">
          <custom-select
            v-model="formSearch.templGroupArray"
            :placeholder="$t('Common.com_please_select')"
            :props="{ label: 'name', value: 'value' }"
            type="tree"
            url="MsgTemplateGroupTree"
            :show-all-levels="false"
            :params="{}"
          ></custom-select>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table v-if="funcView.push_config_list" index tableCode="messagePushConf" :data="pushConfigList" @column="setColumn" @filter="filterChange" @sort="sortChange" height="100%" :slots="['triggerCodeName']">
        <template slot="triggerCodeName" slot-scope="scope">
          <span @click="seePaclageItem(scope.row)" style="color:#00a2df; cursor: pointer" v-if="funcView.push_config_view">{{ scope.row.triggerCodeName }}</span>
          <span v-else>{{ scope.row.triggerCodeName }}</span>
        </template>
        <el-table-column :label="$t('Common.com_handle')" min-width="100" fixed="right">
          <template slot-scope="scope">
            <el-button @click="editPaclageItem(scope.row)" type="text" size="mini" v-if="funcView.push_config_edit">{{ funcView.push_config_edit }}</el-button>
            <el-button @click="deletePaclageItem(scope.row)" type="text" size="mini" v-if="funcView.push_config_delete">{{ funcView.push_config_delete }}</el-button>
          </template>
        </el-table-column>
      </custom-table>
    </div>
    <div class="table-page" v-if="funcView.push_config_list">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <!-- 新增编辑推送规则  -->
    <pushConfig-item-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="getPushConfigList"></pushConfig-item-dialog>
    <!--查看消息推送配置-->
    <pushConfig-conter-dialog v-if="dialogVisible1" :model="dialogModel1" @close="dialogVisible1 = false"></pushConfig-conter-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';
import pushConfigItemDialog from './children/pushConfig_item_dialog';
import pushConfigConterDialog from './children/pushConfig_content_dialog';

export default {
  name: 'pushConfig',
  mixins: [resetFormSearchMixins],
  components: {
    pushConfigItemDialog,
    pushConfigConterDialog,
  },
  data() {
    return {
      pushConfigList: [],
      isLoading: false,
      // 分页
      formSearch: {
        keyword: '',
        msgType: '',
        pageSize: 20,
        pageNum: 1,

        pushRange: '',
        pushRole: '',
        pushChannel: '',
        templGroupArray: '',
        templGroupId: ''
        // templGroupId: '479992728361758720'
      },
      // 推送岗位
      pushRoleList: [],
      totalRows: null,
      // 新增修改弹窗
      dialogVisible: false,
      dialogModel: {},

      // 查看
      dialogVisible1: false,
      dialogModel1: {},
      link: null
    };
  },
  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);

    // 查字典
    this.getDictionary('bas_msg_type');
    this.getUserRoleList();
    this.getPushConfigList();
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });

  },
  methods: {
    // 推送岗位
    getUserRoleList: function () {
      this.$getJSON(apis.UserRole).then((res) => {
        this.pushRoleList = res.data;
      });
    },
    // clearFilter: function () {
    //   this.formSearch.pushRange = '';
    //   this.formSearch.pushRole = '';
    //   this.formSearch.pushChannel = '';
    //   this.formSearch.templGroupId = '';
    //   this.getPushConfigList();
    // },
    // 获取消息推送配置
    getPushConfigList: function () {
      this.isLoading = true;
      // 取最后一项id
      this.formSearch.templGroupId = this.formSearch.templGroupArray.length > 0 ? this.formSearch.templGroupArray[this.formSearch.templGroupArray.length - 1] : '';
      this.$getJSON(apis.PushConfPage, this.formSearch).then((res) => {
        this.isLoading = false;
        const recordsData = res.data.records;
        // 推送对象  消息推送方式 数组变字符串用于展示
        recordsData.forEach((i) => {
          const pushRoleNameString = i.pushRoleName.join(',');
          i.pushRoleName = pushRoleNameString;
          const pushChannelNameString = i.pushChannelName.join(',');
          i.pushChannelName = pushChannelNameString;
          const pushRangeNameString = i.pushRangeName.join(',');
          i.pushRangeName = pushRangeNameString;
          // const pushRangeString = i.pushRange.join(',');
          // i.pushRange = pushRangeString;
        });
        this.pushConfigList = recordsData;
        this.totalRows = res.data.total;
      });
    },
    // 新增推送配置
    addPaclageItem: function () {
      this.dialogModel.type = 'add';
      this.dialogModel.title = this.$t('base_pushConfig.xin_zeng_xiao_xi');
      this.dialogVisible = true;
    },
    // 修改推送配置
    editPaclageItem: function (row) {
      this.dialogModel.type = 'edit';
      this.dialogModel.title = this.$t('base_pushConfig.bian_ji_xiao_xi');
      this.dialogModel.data = row;
      this.dialogVisible = true;
    },
    // 查看推送配置
    seePaclageItem: function (data) {
      this.dialogModel1.type = 'see';
      this.dialogModel1.title = this.$t('base_pushConfig.xiao_xi_xiang_qing');
      this.dialogModel1.data = data;
      this.dialogVisible1 = true;
    },
    // 删除配置
    deletePaclageItem: function ({ triggerCode }) {
      const tips = this.$t('base_pushConfig.nqdyscxzdxxm');
      this.$showConfirm(tips)
        .then(() => {
          this.$deleteJSON(`${apis.PushConfDelete}${triggerCode}`).then(() => {
            this.getPushConfigList();
          });
        })
        .catch(() => {});
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getPushConfigList();
    }
  }
};
</script>

<style lang="scss">
// 修改默认的margin-left

.pushconfig-bd {
  .aside {
    .title {
      padding: 14px 10px;
      line-height: 24px;
      color: #404040;
      font-weight: bold;
      font-size: 16px;
    }
    .search {
      margin: 0 10px;
    }
    .el-collapse-item__content {
      padding-bottom: 10px;
    }
    .el-collapse {
      border-top: none;
      border-bottom: none;
    }
    .el-collapse-item {
      margin-bottom: 8px;
    }
    .el-collapse-item__header {
      border: 1px solid rgba(228, 228, 228, 1);
      background-color: rgba(240, 243, 249, 1);
      height: 34px;
      line-height: 34px;
      padding-left: 10px;
      color: #404040;
      font-size: 12px;
      font-weight: bold;
    }
    .el-collapse-item__wrap {
      padding: 10px;
      border-left: 1px solid rgba(228, 228, 228, 1);
      border-right: 1px solid rgba(228, 228, 228, 1);
      border-bottom: 1px solid rgba(228, 228, 228, 1);
    }
    .is-current > .el-tree-node__content {
      background-color: #f0f3f9;
    }
  }
  .section {
    .title {
      color: #404040;
      font-size: 16px;
      line-height: 24px;
      padding-top: 10px;
      font-weight: bold;
      i {
        margin-right: 5px;
        color: #404040;
      }
    }
    .info-bd {
      padding: 11px 10px 5px;
      height: 66px;

      .label {
        color: #727272;
        font-size: 12px;
        line-height: 17px;
      }
      .value {
        color: #404040;
        font-size: 12px;
        line-height: 17px;
      }
    }
  }
}
</style>
